import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options, label, disabled, name }) {
    return (
        <div className="ns-relative">
            <select
                className={`${className}`}
                value={value}
                onChange={onChange}
                aria-label={label || "Select"}
                name={name || label}
            >
                {disabled && 
                    <option value="" disabled>{disabled || "Select an option"}</option>
                }
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}
